import { Container } from "@amzn/awsui-components-react/polaris";
import React, { useEffect } from "react";
import { CollectionsList } from "../Account/CollectionsList";
import { useGetAccountCollectionsListQuery } from "../../hooks/Account/useGetAccountCollectionsListQuery";
import { useParams } from "react-router-dom";
import { JunoAccountOverviewParams } from "../../../models/types";

const CollectionGroupCollectionsList = (props) => {
    const { awsAccountId } = useParams<JunoAccountOverviewParams>();
    const [
        getAccountCollectionsList,
        { loading: accountCollectionListLoading, data: accountCollectionList },
    ] = useGetAccountCollectionsListQuery();

    useEffect(() => {
        if (props.collectionGroupDetails?.name) {
            // get collections for cg
            getAccountCollectionsList({
                variables: {
                    awsAccountId: awsAccountId,
                    collectionGroupName: props.collectionGroupDetails.name,
                },
            })
        }
    }, [awsAccountId, props.collectionGroupDetails?.name]);

    return (
        <Container
            disableContentPaddings
            disableHeaderPaddings
            >
            <CollectionsList
                accountCollectionListLoading={accountCollectionListLoading}
                accountCollectionList={accountCollectionList}
                awsAccountId={awsAccountId}
            />
        </Container>
    );
};

export { CollectionGroupCollectionsList }
